import { Lock, Phone, MapPin } from "lucide-react";
import { useSite } from "../context/SiteContext";
import { imgUrl } from "../api";

export default function Footer() {
    const { content, setAdminOpen, t, cf } = useSite();
    const year = new Date().getFullYear();

    return (
        <footer data-testid="site-footer" className="relative border-t border-gold/15 bg-[#08080A]">
            <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-16">
                <div className="grid md:grid-cols-3 gap-10 items-start">
                    <div>
                        <div className="flex items-center gap-3">
                            {content?.logo_url && (
                                <img src={imgUrl(content.logo_url)} alt="Logo" className="h-12 w-12 rounded-full object-cover ring-1 ring-gold/50" />
                            )}
                            <span className="font-serif text-xl text-amber-50">{content?.business_name}</span>
                        </div>
                        <p className="mt-4 text-sm text-zinc-500 font-light leading-relaxed max-w-xs">
                            {cf("tagline")}
                        </p>
                    </div>
                    <div className="space-y-3 text-sm text-zinc-400 font-light">
                        <p className="flex items-center gap-2.5">
                            <Phone size={14} className="text-gold" />
                            {content?.phone}
                        </p>
                        <p className="flex items-start gap-2.5">
                            <MapPin size={14} className="text-gold mt-0.5 shrink-0" />
                            {content?.address}
                        </p>
                    </div>
                    <div className="flex md:justify-end gap-6 text-sm">
                        <a href="#servicios" data-testid="footer-link-servicios" className="text-zinc-400 hover:text-gold transition-colors">Servicios</a>
                        <a href="#galeria" data-testid="footer-link-galeria" className="text-zinc-400 hover:text-gold transition-colors">Galería</a>
                        <a href="#contacto" data-testid="footer-link-contacto" className="text-zinc-400 hover:text-gold transition-colors">Contacto</a>
                    </div>
                </div>

                <div className="mt-12 pt-8 border-t border-gold/10 flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="text-xs text-zinc-600 font-light" data-testid="footer-copyright">
                        © {year} {content?.business_name} · {t.footer.rights}
                    </p>
                    <button
                        onClick={() => setAdminOpen(true)}
                        data-testid="admin-access-button"
                        aria-label="Acceso administrativo"
                        title="Acceso administrativo"
                        className="opacity-25 hover:opacity-100 text-zinc-400 hover:text-gold transition-all duration-300 p-2"
                    >
                        <Lock size={13} />
                    </button>
                </div>
            </div>
        </footer>
    );
}
